import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import {
    IRolodexContactDTO,
    IRolodexContactsSearchParams,
    IRolodexDAO,
    IUpdateAttendeeRolodexMappingParams,
    TUpdateRolodexContactRequestParams
} from '../rolodex.dao';
import * as ROLODEX_API from '../../constants/api/rolodex-api.constants';
import * as ATTENDEE_API from '../../constants/api/attendee-api.constants';
import { Permission } from '../roles.dao';

class RolodexDAO extends IRolodexDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async searchContacts(params: IRolodexContactsSearchParams): Promise<IRolodexContactDTO[]> {
        const response = await this.apiClient.get<IRolodexContactDTO[]>(ROLODEX_API.ROLODEX_CONTACTS_SEARCH_URL, params);
        return response.parsedResponse;
    }

    public async getContact(params: { contactId: number }): Promise<IRolodexContactDTO> {
        const response = await this.apiClient.get<IRolodexContactDTO>(ROLODEX_API.ROLODEX_CONTACT_URL, params);
        return response.parsedResponse;
    }

    public async updateAttendeeMapping(params: IUpdateAttendeeRolodexMappingParams): Promise<void> {
        await this.apiClient.put<void>(
            {
                url: ATTENDEE_API.UPDATE_ATTENDEE_ROLODEX_MAPPING_URL,
                permission: Permission.MANAGE_ATTENDEE_ROLODEX_MAPPING
            },
            params
        );
    }

    public async updateRolodexContact(params: TUpdateRolodexContactRequestParams): Promise<IRolodexContactDTO> {
        const response = await this.apiClient.put<IRolodexContactDTO>(
            {
                url: ROLODEX_API.ROLODEX_CONTACT_URL,
                permission: Permission.EDIT_ROLODEX_CONTACT
            },
            params
        );
        return response.parsedResponse;
    }
}

export { RolodexDAO };
